module.exports = __webpack_public_path__ + "img/editing.341484a0.svg";